import React from "react";

// import Anchor from "../../../component/Anchor";
import { CONTACT_US } from "npmlinks-constants";

const ContactUsMessage = () => {
  const teleAttribute = "tel:";
  const mailAttribute = "mailto:";
  return (
    <div className="nw-contactusmessage-container">
      <div className="nw-contactusmessage-detail">
        <h2 className="nw-contactusmessage-message">
          {" "}
          {CONTACT_US.message1.message}{" "}
        </h2>
        <h4 className="nw-contactusmessage-info">
          <a
            href={`${teleAttribute} ${CONTACT_US.message1.info}`}
            className="nw-contactusmessage-anchor"
          >
            {CONTACT_US.message1.info}
          </a>
        </h4>
        <h4 className="nw-contactusmessage-info">
          {" "}
          {CONTACT_US.message1.detail}{" "}
        </h4>
      </div>
      <div className="nw-contactusmessage-detail">
        <h2 className="nw-contactusmessage-message">
          {" "}
          {CONTACT_US.message2.message}{" "}
        </h2>
        <h4 className="nw-contactusmessage-info">
          <a
            href={`${mailAttribute} ${CONTACT_US.message2.info}`}
            className="nw-contactusmessage-anchor"
          >
            {CONTACT_US.message2.info}
          </a>
        </h4>
      </div>
    </div>
  );
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ContactUsMessage,
  component: ContactUsMessage,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/V1/ContactUsMessage/index.js